import PortConfigurationOperation from '../PortConfiguratorOperation'
import { FinalStepLeft } from './FinalStepLeft'
import React from 'react'

export function FinalStepLeftStandalone (props) {
  let order = props.order
  return (
    <PortConfigurationOperation prefix={'thx'} initialPorts={order}>
      <FinalStepLeft showModal={false}/>
    </PortConfigurationOperation>
  )
}